var map = {
	"./barbara.png": 682,
	"./bg_ballons1.png": 683,
	"./bg_ballons2.png": 684,
	"./bg_gelb.png": 685,
	"./gp1.png": 686,
	"./gpbleibtbunt.png": 162,
	"./gruppe.png": 687,
	"./julia.png": 688,
	"./michael.png": 689,
	"./papagei.png": 690
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 681;